/* ============================================
   STILENZA — Product Detail Page
   Gallery, zoom, variants, modals, sticky ATC
   ============================================ */
(function() {
  'use strict';

  let product, variantMediaMap, selectedOptions = {};
  let form, variantInput, atcBtn, stockMsg, stickyBtn, stickyPrice;
  let _labels = {};
  const _observers = [];

  // Shared utility from theme.liquid, with local fallback
  const formatPrice = window.__stilFormatMoney || function(cents) {
    // Noodgeval: theme.liquid definieert window.__stilFormatMoney normaal altijd.
    return ((Number(cents) || 0) / 100).toFixed(2);
  };

  // Vertaling ophalen zonder ||: een lege vertaling is een geldige waarde, maar
  // falsy in JavaScript. Zonder dit onderscheid kreeg de Japanse markt de Engelse
  // terugval te zien zodra een vertaling bewust leeg was.
  function label(sleutel, terugval) {
    const v = _labels[sleutel];
    return v === undefined || v === null ? terugval : v;
  }

  // De schrijfwijze van een korting verschilt per markt: "-23%" in Europa en de VS,
  // "23%OFF" in Japan. Het sjabloon komt uit de locales via een data-attribuut, met
  // __PCT__ als plaatshouder, zodat liquid en js dezelfde vertaling delen.
  function kortingLabel(pct) {
    return label('labelDiscountBadge', '-__PCT__%').replace('__PCT__', pct);
  }

  function init() {
    const dataEl = document.getElementById('stilenza-product-data');
    if (!dataEl) return;
    product = JSON.parse(dataEl.textContent);

    // Read translatable labels from section wrapper data attributes
    const sectionEl = document.querySelector('.stil-pdp[data-label-add-to-bag]');
    _labels = sectionEl ? sectionEl.dataset : {};

    const mediaMapEl = document.getElementById('stilenza-variant-media');
    variantMediaMap = mediaMapEl ? JSON.parse(mediaMapEl.textContent) : {};

    form = document.getElementById('stilenza-product-form');
    if (!form) return;
    variantInput = form.querySelector('[data-variant-id]');
    atcBtn = form.querySelector('.stil-pdp__atc-btn');
    stockMsg = document.getElementById('StilenzaStockMsg');
    stickyBtn = document.getElementById('StilenzaStickyBtn');
    stickyPrice = document.getElementById('StilenzaStickyPrice');

    // Initialize selected options from current variant
    const initialOptions = variantInput ? findVariantById(parseInt(variantInput.value)) : null;
    if (initialOptions) {
      product.options.forEach(function(_, i) {
        selectedOptions[i] = initialOptions.options[i];
      });
      // De prijs op de knop meteen door dezelfde formatter halen als bij een
      // variantwissel. Liquid schrijft hem met shop.money_format (winkelbreed),
      // deze js met Intl per markt — dat verschilt in het scheidingsteken, en
      // zonder deze regel sprong het bedrag middenin de koopknop van 47,95 naar
      // 47.95 zodra iemand een kleur koos.
      if (initialOptions.available) {
        zetStickyKnop(_labels.labelAddToBag || 'ADD TO BAG', formatPrice(initialOptions.price));
      }
    }

    initGallery();
    initZoomModal();
    initVariants();
    initSizeIndicator();
    initAccordions();
    initStickyATC();
    initAJAXCart();
    initRecentlyViewed();
    initLook();
    initPriceSplit();
    initKoerierPerLand();
    updateStockMessage(initialOptions);

    // De galerij opende altijd op foto 1, ook als de gekozen variant een andere
    // kleur is. Op deze jurk stond "赤" geselecteerd met de prijs van rood ernaast,
    // terwijl foto 1 de zwarte was. Bij een kleurwissel klopte het wel — alleen de
    // begintoestand niet. In een rAF omdat initGallery op mobiel zelf nog naar het
    // eerste echte item scrolt; dit moet daarna komen.
    if (initialOptions) {
      requestAnimationFrame(function() {
        scrollToVariantImage(initialOptions, true);
      });
    }
  }

  // --- Helpers ---
  function findVariantById(id) {
    for (let i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  function findVariantByOptions() {
    return product.variants.find(function(v) {
      return product.options.every(function(_, i) {
        return v.options[i] === selectedOptions[i];
      });
    });
  }

  let galleryLockedIndex = 0;


  function formatPriceSplit(cents) {
    const formatted = formatPrice(cents);
    return formatted.replace(/^([^\d\s]+)/, '<span class="stil-pdp__price-currency">$1</span>');
  }


  // ============================================
  // GALLERY — sticky panel + thumbnail rail
  // ============================================
  function setGalleryActiveIndex(idx) {
    const gallery = document.getElementById('StilenzaGallery');
    const rail = document.getElementById('StilenzaGalleryRail');
    const dotsWrap = document.getElementById('StilenzaGalleryDots');
    if (!gallery) return;

    const items = gallery.querySelectorAll('.stil-pdp__gallery-item:not(.stil-pdp__gallery-clone)');
    const thumbs = rail ? rail.querySelectorAll('.stil-pdp__rail-thumb') : [];
    const dots = dotsWrap ? dotsWrap.querySelectorAll('.stil-pdp__dot') : [];

    items.forEach(function(item, i) {
      item.classList.toggle('is-active', i === idx);
    });
    thumbs.forEach(function(thumb, i) {
      thumb.classList.toggle('is-active', i === idx);
      if (i === idx) thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === idx);
    });

    // Update gallery counter
    const counterEl = document.getElementById('StilenzaGalleryCounter');
    if (counterEl) {
      const currentSpan = counterEl.querySelector('.counter-current');
      if (currentSpan) {
        currentSpan.textContent = String(idx + 1);
      }
    }

    // Update mobile progress segments (Gucci-style: active block = black)
    const progressSegs = document.querySelectorAll('.stil-pdp__progress-seg');
    if (progressSegs.length) {
      progressSegs.forEach(function(seg, i) {
        seg.classList.toggle('is-active', i === idx);
      });
    }
  }

  function initGallery() {
    const gallery = document.getElementById('StilenzaGallery');
    const rail = document.getElementById('StilenzaGalleryRail');
    if (!gallery) return;

    const items = gallery.querySelectorAll('.stil-pdp__gallery-item');
    const totalImages = items.length;
    if (totalImages <= 1) return;

    // Desktop: prev / next arrow buttons
    if (window.innerWidth >= 990) {
      const realItemCount = gallery.querySelectorAll('.stil-pdp__gallery-item:not(.stil-pdp__gallery-clone)').length;
      const prevBtn = document.getElementById('StilenzaGalleryPrev');
      const nextBtn = document.getElementById('StilenzaGalleryNext');
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          galleryLockedIndex = (galleryLockedIndex + 1) % realItemCount;
          setGalleryActiveIndex(galleryLockedIndex);
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          galleryLockedIndex = (galleryLockedIndex - 1 + realItemCount) % realItemCount;
          setGalleryActiveIndex(galleryLockedIndex);
        });
      }

      // Duimnagels aanklikbaar. Die stonden tot nu toe op display:none, dus er
      // was nooit een klik-afhandeling voor gemaakt - setGalleryActiveIndex zette
      // alleen de actieve rand op de juiste miniatuur. Nu de rail zichtbaar is,
      // is dit de belangrijkste manier om door de foto's te gaan.
      if (rail) {
        rail.querySelectorAll('.stil-pdp__rail-thumb').forEach(function(thumb) {
          thumb.addEventListener('click', function() {
            const i = parseInt(thumb.dataset.thumbIndex, 10);
            if (isNaN(i)) return;
            galleryLockedIndex = i;
            setGalleryActiveIndex(i);
          });
        });
      }
    }

    // Mobile: infinite loop gallery
    if (window.innerWidth < 990) {
      // Thumbs onder de foto (stz, aug 2026): klik springt naar de echte
      // slide. Bestond alleen voor desktop — daar wisselt hij op opacity,
      // hier scrollen we de strip.
      if (rail) {
        rail.querySelectorAll('.stil-pdp__rail-thumb').forEach(function(thumb) {
          thumb.addEventListener('click', function() {
            const i = parseInt(thumb.dataset.thumbIndex, 10);
            if (isNaN(i)) return;
            const doel = gallery.querySelector('.stil-pdp__gallery-item:not(.stil-pdp__gallery-clone)[data-index="' + i + '"]');
            if (doel) gallery.scrollTo({ left: doel.offsetLeft, behavior: 'smooth' });
          });
        });
      }

      // Clone last item to beginning, first item to end
      const firstClone = items[0].cloneNode(true);
      const lastClone = items[totalImages - 1].cloneNode(true);
      firstClone.classList.add('stil-pdp__gallery-clone');
      firstClone.removeAttribute('data-index');
      firstClone.setAttribute('data-clone-of', '0');
      lastClone.classList.add('stil-pdp__gallery-clone');
      lastClone.removeAttribute('data-index');
      lastClone.setAttribute('data-clone-of', String(totalImages - 1));
      gallery.insertBefore(lastClone, items[0]);
      gallery.appendChild(firstClone);

      // Scroll to real first item (index 0) without animation
      requestAnimationFrame(function() {
        const realFirst = gallery.querySelector('[data-index="0"]');
        if (realFirst) {
          gallery.style.scrollBehavior = 'auto';
          gallery.scrollLeft = realFirst.offsetLeft;
          gallery.style.scrollBehavior = '';
        }
      });

      // Track active index via IntersectionObserver on real items only
      const realItems = gallery.querySelectorAll('.stil-pdp__gallery-item:not(.stil-pdp__gallery-clone)');
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.target.dataset.index !== undefined) {
            const idx = parseInt(entry.target.dataset.index);
            setGalleryActiveIndex(idx);
          }
        });
      }, { root: gallery, threshold: 0.5 });
      _observers.push(observer);
      realItems.forEach(function(item) { observer.observe(item); });

      // Jump to real item when clone becomes visible
      const clones = gallery.querySelectorAll('.stil-pdp__gallery-clone');
      const cloneObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const cloneOf = parseInt(entry.target.getAttribute('data-clone-of'));
            const target = gallery.querySelector('[data-index="' + cloneOf + '"]');
            if (target) {
              gallery.style.scrollSnapType = 'none';
              gallery.style.scrollBehavior = 'auto';
              gallery.scrollLeft = target.offsetLeft;
              requestAnimationFrame(function() {
                gallery.style.scrollSnapType = 'x mandatory';
                gallery.style.scrollBehavior = '';
              });
            }
          }
        });
      }, { root: gallery, threshold: 0.8 });
      _observers.push(cloneObserver);
      clones.forEach(function(clone) { cloneObserver.observe(clone); });
    }

    // Ensure first item is active on load
    setGalleryActiveIndex(0);
  }

  // direct = zonder animatie. Bij het laden van de pagina hoort de juiste foto er
  // gewoon te staan; een galerij die uit zichzelf begint te schuiven leest als een
  // storing. Bij een kleurwissel is de beweging juist de bevestiging van de klik.
  function scrollGalleryToIndex(index, direct) {
    const gallery = document.getElementById('StilenzaGallery');
    if (!gallery) return;
    const items = gallery.querySelectorAll('.stil-pdp__gallery-item');
    if (index < 0 || index >= items.length) return;

    galleryLockedIndex = index;
    setGalleryActiveIndex(index);

    const gedrag = direct ? 'auto' : 'smooth';
    const targetItem = gallery.querySelectorAll('.stil-pdp__gallery-item:not(.stil-pdp__gallery-clone)')[index] || items[index];
    if (window.innerWidth < 990) {
      // Mobile: scroll gallery horizontally
      if (targetItem) gallery.scrollTo({ left: targetItem.offsetLeft, behavior: gedrag });
    } else if (!direct) {
      // Desktop: scroll page to the image. Bij het laden niet — dan zou de pagina
      // onder de bezoeker vandaan springen nog voor hij iets gedaan heeft.
      if (targetItem) targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ============================================
  // PDP HEADER — transparent over gallery on mobile
  // ============================================
  // initPDPHeader verwijderd (aug 2026): de PDP gebruikt de gewone
  // site-header nu de kop boven de galerij staat.

  // ============================================
  // ZOOM MODAL
  // ============================================
  function initZoomModal() {
    const modal = document.getElementById('StilenzaZoomModal');
    const track = document.getElementById('StilenzaZoomTrack');
    const counterEl = document.getElementById('StilenzaZoomCounter');
    const closeBtn = modal ? modal.querySelector('.stil-pdp__zoom-close') : null;
    const prevBtn = modal ? modal.querySelector('.stil-pdp__zoom-nav--prev') : null;
    const nextBtn = modal ? modal.querySelector('.stil-pdp__zoom-nav--next') : null;

    if (!modal || !track) return;

    const gallery = document.getElementById('StilenzaGallery');
    const galleryItems = gallery ? gallery.querySelectorAll('.stil-pdp__gallery-item') : [];
    const imageUrls = [];
    let currentZoomIndex = 0;
    let totalImages = 0;

    // Collect image URLs
    galleryItems.forEach(function(item) {
      const img = item.querySelector('img[data-zoom-src]');
      if (img) {
        imageUrls.push({
          zoom: img.dataset.zoomSrc,
          alt: img.alt
        });
      }
    });
    totalImages = imageUrls.length;
    if (totalImages === 0) return;

    function openZoom(index) {
      currentZoomIndex = index;
      renderZoomImage();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeZoom() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Clear zoomed images to free memory
      track.innerHTML = '';
    }

    function renderZoomImage() {
      if (window.innerWidth >= 990) {
        // Desktop: single image with click-to-zoom
        track.innerHTML = '<div class="stil-pdp__zoom-img-wrap"><img src="' +
          imageUrls[currentZoomIndex].zoom + '" alt="' +
          imageUrls[currentZoomIndex].alt + '"></div>';

        const wrap = track.querySelector('.stil-pdp__zoom-img-wrap');
        const img = wrap.querySelector('img');

        wrap.addEventListener('click', function(e) {
          if (wrap.classList.contains('is-zoomed')) {
            wrap.classList.remove('is-zoomed');
            img.style.transformOrigin = '';
          } else {
            const rect = wrap.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
            const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
            img.style.transformOrigin = x + '% ' + y + '%';
            wrap.classList.add('is-zoomed');
          }
        });
      } else {
        // Mobile: all images in scroll container
        let html = '';
        for (let i = 0; i < imageUrls.length; i++) {
          html += '<div class="stil-pdp__zoom-img-wrap"><img src="' +
            imageUrls[i].zoom + '" alt="' + imageUrls[i].alt + '" loading="lazy"></div>';
        }
        track.innerHTML = html;

        // Scroll to current index
        const wraps = track.querySelectorAll('.stil-pdp__zoom-img-wrap');
        if (wraps[currentZoomIndex]) {
          wraps[currentZoomIndex].scrollIntoView({ inline: 'start' });
        }

        // Mobile scroll tracking for counter
        const mobileObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              const idx = Array.prototype.indexOf.call(wraps, entry.target);
              if (idx >= 0) {
                currentZoomIndex = idx;
                updateZoomCounter();
              }
            }
          });
        }, { root: track, threshold: 0.5 });
        _observers.push(mobileObserver);

        wraps.forEach(function(w) { mobileObserver.observe(w); });
      }
      updateZoomCounter();
    }

    function updateZoomCounter() {
      if (counterEl) counterEl.textContent = (currentZoomIndex + 1) + ' / ' + totalImages;
    }

    function navigate(dir) {
      currentZoomIndex = (currentZoomIndex + dir + totalImages) % totalImages;
      renderZoomImage();
    }

    // Click gallery items to open zoom
    galleryItems.forEach(function(item, i) {
      item.addEventListener('click', function() {
        // Only open for image items (count images before this index)
        let imgIndex = 0;
        for (let j = 0; j < i; j++) {
          if (galleryItems[j].querySelector('img[data-zoom-src]')) imgIndex++;
        }
        if (item.querySelector('img[data-zoom-src]')) {
          openZoom(imgIndex);
        }
      });
    });

    // Controls
    if (closeBtn) closeBtn.addEventListener('click', closeZoom);
    if (prevBtn) prevBtn.addEventListener('click', function() { navigate(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { navigate(1); });

    // Keyboard
    document.addEventListener('keydown', function(e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    // Backdrop click (close)
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeZoom();
    });
  }

  // ============================================
  // 実寸 — WERKELIJKE AFMETINGEN PER MAAT
  // ============================================
  // Japanse maten vallen kleiner uit dan Europese, dus "M" zegt een Japanse koper
  // niets en de centimeters wel. De regel staat alleen in de markup als de vertaling
  // én het metafield gevuld zijn, dus in andere markten doet dit niets.
  function renderJissun(size) {
    const el = document.getElementById('StilenzaJissun');
    if (!el || !size) return;

    let sizes, labels;
    try {
      sizes = JSON.parse(el.dataset.sizes || '{}');
      labels = JSON.parse(el.dataset.labels || '{}');
    } catch (err) {
      el.textContent = '';
      return;
    }

    // Maatsleutels kunnen als "M" of "m " in het metafield staan; los matchen op
    // hoofdletters en spaties, anders blijft de regel leeg zonder dat iemand ziet waarom.
    const wanted = String(size).trim().toUpperCase();
    const key = Object.keys(sizes).find(function(k) {
      return String(k).trim().toUpperCase() === wanted;
    });
    const row = key ? sizes[key] : null;
    if (!row) { el.textContent = ''; return; }

    const parts = [];
    ['shoulder', 'chest', 'length', 'sleeve'].forEach(function(metric) {
      const value = row[metric];
      if (value === undefined || value === null || value === '') return;
      parts.push((labels[metric] || metric) + ' ' + value + 'cm');
    });
    if (!parts.length) { el.textContent = ''; return; }

    // De vertaling bevat § als plek voor de maatnaam (zie stilenza-product.liquid).
    const prefix = (el.dataset.prefix || '').replace('§', size);
    el.textContent = prefix + parts.join(' ・ ');
  }

  // ============================================
  // VARIANT SELECTION
  // ============================================
  function initVariants() {
    const optionBtns = document.querySelectorAll('.stil-pdp__swatch, .stil-pdp__size');

    optionBtns.forEach(function(btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function() {
        const idx = parseInt(this.dataset.optionIndex);
        const val = this.dataset.value;
        selectedOptions[idx] = val;

        // Update selection UI — for swatch/size buttons in info panel
        this.parentElement.querySelectorAll('.is-selected').forEach(function(s) {
          s.classList.remove('is-selected');
          if (s.hasAttribute('aria-pressed')) s.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('is-selected');
        if (this.hasAttribute('aria-pressed')) this.setAttribute('aria-pressed', 'true');

        // 実寸 — werkelijke afmetingen van de gekozen maat, in centimeters.
        if (this.classList.contains('stil-pdp__size')) renderJissun(val);

        // Size nudge — temporarily highlight the size guide link after picking a size
        if (this.classList.contains('stil-pdp__size')) {
          const sgBtn = document.getElementById('size-chart-open') || document.querySelector('[data-open-size-guide]');
          if (sgBtn) {
            clearTimeout(window.__nudgeTimer__);
            // De pas-tekst \u00e9\u00e9n keer bewaren, niet bij elke klik. Koos de klant binnen
            // 3,5 seconden een tweede maat, dan werd de nudge van de vorige maat als
            // "origineel" opgeslagen en stond daarna de verkeerde maat in de knop.
            if (!sgBtn.dataset.stilLabel) sgBtn.dataset.stilLabel = sgBtn.innerHTML;
            // Niet met || : een lege vertaling is een geldige waarde. Japans zet de
            // vraag achteraan ("XL \u306e\u30b5\u30a4\u30ba\u3067\u304a\u60a9\u307f\u3067\u3059\u304b\uff1f"), dus daar is het voorvoegsel
            // bewust leeg \u2014 en dat is falsy, waardoor || de Engelse tekst terugzette.
            sgBtn.innerHTML = label('labelSizeNudgePrefix', 'Not sure about ') + val +
                              label('labelSizeNudgeSuffix', '? \u2192');
            sgBtn.style.color = 'var(--color-text)';
            sgBtn.style.fontWeight = '600';
            window.__nudgeTimer__ = setTimeout(function() {
              sgBtn.innerHTML = sgBtn.dataset.stilLabel;
              sgBtn.style.color = '';
              sgBtn.style.fontWeight = '';
            }, 3500);
          }
        }

        // Update option label — data-label is de vertaalde kleurnaam uit het
        // color-pattern metaobject; data-value is de ruwe optiewaarde waarmee de
        // variant wordt gezocht en die staat meestal in het Engels. Stond hier val,
        // dan rende de pagina goed in het Japans ("色: 黒") en sloeg de eerste klik
        // hem terug naar "色: DARK GREEN". Maatknoppen dragen geen data-label en
        // vallen dus vanzelf terug op de waarde zelf.
        // NIET 'label' noemen: dat is de naam van de vertaal-helper bovenaan dit
        // bestand. Een const met dezelfde naam verduistert die voor de hele
        // handler, ook op de regels erbóven — en daar wordt label() aangeroepen
        // voor de maat-nudge. Dat gooide "Cannot access 'label' before
        // initialization", de handler brak af, en de verborgen variant-input werd
        // nooit bijgewerkt. De maat kleurde geselecteerd, maar in de wagen belandde
        // de variant waarmee de pagina laadde: de kleinste maat.
        const optionLabelEl = document.querySelector('[data-option-selected="' + idx + '"]');
        if (optionLabelEl) optionLabelEl.textContent = this.dataset.label || val;


        // Find matching variant
        const variant = findVariantByOptions();
        if (!variant) return;

        // Update hidden input
        variantInput.value = variant.id;

        // Update price with currency split
        const price = formatPrice(variant.price);
        const priceCurrentEl = document.querySelector('.stil-pdp__price-current');
        const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (priceCurrentEl) {
          priceCurrentEl.innerHTML = formatPriceSplit(variant.price);
          priceCurrentEl.classList.toggle('is-on-sale', !!isOnSale);
          priceCurrentEl.classList.toggle('is-sale', !!isOnSale);
        }

        // Compare-prijs + savepill. De pill draagt zijn vertaalde sjabloon als
        // data-template (label()-patroon): __A__ = bedrag, __P__ = percentage.
        const compareEl = document.querySelector('.stil-pdp__price-compare');
        const pillEl = document.querySelector('.stz__savepill');
        if (isOnSale) {
          const discountPct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          if (compareEl) { compareEl.textContent = formatPrice(variant.compare_at_price); compareEl.style.display = ''; }
          else {
            const newCompare = document.createElement('span');
            newCompare.className = 'stil-pdp__price-compare stz__was';
            newCompare.textContent = formatPrice(variant.compare_at_price);
            priceCurrentEl.parentNode.insertBefore(newCompare, priceCurrentEl.nextSibling);
          }
          if (pillEl && pillEl.dataset.template) {
            pillEl.textContent = pillEl.dataset.template
              .replace('__A__', formatPrice(variant.compare_at_price - variant.price))
              .replace('__P__', discountPct);
            pillEl.style.display = '';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (pillEl) pillEl.style.display = 'none';
        }


        // Prijs in de koopknop (stz__atc) volgt de variant mee. Staat er een
        // pakket-trede aan, dan wint het pakkettotaal (pakketVariantGewisseld).
        const atcPrijs = document.querySelector('.stz__atc .stz__atcprijs');
        if (atcPrijs) atcPrijs.textContent = formatPrice(variant.price);


        // Update gallery sale badge
        const galBadge = document.getElementById('StilenzaGallerySaleBadge');
        if (isOnSale) {
          const galPct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          if (galBadge) { galBadge.textContent = kortingLabel(galPct); galBadge.style.display = ''; }
        } else {
          if (galBadge) galBadge.style.display = 'none';
        }
        if (variant.available) {
          atcBtn.disabled = false;
          zetKoopKnop(_labels.labelAddToBag || 'ADD TO CART', price);
          if (stickyBtn) {
            stickyBtn.disabled = false;
            zetStickyKnop(_labels.labelAddToBag || 'ADD TO BAG', price);
          }
        } else {
          atcBtn.disabled = true;
          zetKoopKnop(_labels.labelSoldOut || 'SOLD OUT', '');
          if (stickyBtn) {
            stickyBtn.disabled = true;
            zetStickyKnop(_labels.labelSoldOut || 'SOLD OUT', '');
          }
        }
        if (stickyPrice) stickyPrice.textContent = price;

        // Update sticky variant text
        const stickyVariant = document.getElementById('StilenzaStickyVariant');
        // variant.title bestaat uit de ruwe optiewaarden, en die zijn buiten de
        // brontaal niet vertaald \u2014 dan las de sticky balk "Orange \u00b7 S" terwijl de
        // kiezer erboven \u30aa\u30ec\u30f3\u30b8 zei. We lezen de labels van de kiezer zelf:
        // data-label op de swatch is de vertaalde kleurnaam, de maatknop toont zijn
        // eigen tekst. Lukt dat niet, dan de oude weergave als terugval.
        if (stickyVariant) {
          const delen = [];
          document.querySelectorAll('.stil-pdp__swatch.is-selected').forEach(function(s) {
            delen.push(s.dataset.label || s.dataset.value || '');
          });
          document.querySelectorAll('.stil-pdp__size.is-selected').forEach(function(s) {
            delen.push((s.dataset.value || s.textContent).trim().split('\n')[0]);
          });
          const tekst = delen.filter(Boolean).join(' \u00b7 ');
          stickyVariant.textContent = tekst || variant.title.replace(/ \/ /g, ' \u00b7 ');
        }

        // Update URL
        window.history.replaceState({}, '', '?variant=' + variant.id);

        // Stock message
        updateStockMessage(variant);

        // Scroll gallery to variant image
        scrollToVariantImage(variant);
      });
    });

    // Bij het laden meteen vullen: anders staat de regel leeg tot iemand een maat
    // aanklikt, terwijl er al een maat voorgeselecteerd is.
    const preselected = document.querySelector('.stil-pdp__size.is-selected');
    if (preselected) renderJissun(preselected.dataset.value);
  }


  function buildStockChip(qty, sizeLabel) {
    const tail = sizeLabel ? (_labels.labelLeftIn || ' left in ') + sizeLabel : (_labels.labelLeft || ' left');
    return '<span class="stil-pdp__fitline-sep">·</span>' +
      '<span class="stil-pdp__stock-chip">' +
      '<span class="stil-pdp__stock-dot"></span>' +
      '<span>' + (_labels.labelOnly || 'Only ') + qty + tail + '</span>' +
      '</span>';
  }

  function updateStockMessage(variant) {
    // Urgency now rendered server-side inside size buttons (sale products only).
    return;
    /* eslint-disable no-unreachable */
    let sizeLabel = '';
    for (let i = 0; i < product.options.length; i++) {
      const optName = product.options[i].toLowerCase();
      if (optName === 'size' || optName === 'maat') {
        sizeLabel = variant.options[i];
        break;
      }
    }

    // Real inventory: use actual count if tracked and low
    if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
      stockMsg.innerHTML = buildStockChip(variant.inventory_quantity, sizeLabel);
      return;
    }

    // Verzonnen schaarste is hier weggehaald: die toonde bij ongeveer een derde van
    // de varianten "nog 2 over", berekend uit het variant-ID. Alleen de tak hierboven
    // blijft over, en die gaat af op de werkelijke voorraad uit Shopify.
    stockMsg.innerHTML = '';
  }

  // De prijs staat mee op de vaste koopknop. Vandaar losse spans in plaats van
  // textContent: dat laatste zou ze allebei wegvagen en de prijs verdwijnen
  // zodra iemand een andere variant koos.
  // De parameter heet bewust niet 'label': bovenin dit bestand staat
  // function label() voor vertalingen, en een gelijknamige parameter
  // verduistert die voor de hele functie. Dat is precies de constructie die
  // eerder de maatkeuze sloopte.
  // De koopknop bestaat uit een label-span en een prijs-small. textContent op de
  // knop zelf vaagt die twee weg — daarna was de prijs voorgoed verdwenen zodra
  // iemand had toegevoegd of een uitverkochte maat koos. Alles wat de knop
  // beschrijft loopt daarom hierlangs.
  function zetKoopKnop(tekst, prijs) {
    if (!atcBtn) return;
    const l = atcBtn.querySelector('.stil-cta__label');
    const s = atcBtn.querySelector('.stz__atcprijs');
    if (l) { l.textContent = tekst; } else { atcBtn.textContent = tekst; return; }
    if (s) s.textContent = prijs || '';
  }

  function huidigePrijsTekst() {
    const el = stickyBtn && stickyBtn.querySelector('[data-sticky-btn-price]');
    return el ? el.textContent : '';
  }

  function zetStickyKnop(knopTekst, prijs) {
    if (!stickyBtn) return;
    const tekstEl = stickyBtn.querySelector('[data-sticky-btn-label]');
    const prijsEl = stickyBtn.querySelector('[data-sticky-btn-price]');
    if (!tekstEl) { stickyBtn.textContent = knopTekst; return; }
    tekstEl.textContent = knopTekst;
    if (prijsEl) prijsEl.textContent = prijs || '';
  }

  function scrollToVariantImage(variant, direct) {
    if (!variant || !variantMediaMap) return;
    const mediaIndex = variantMediaMap[variant.id];
    if (mediaIndex !== undefined) {
      scrollGalleryToIndex(mediaIndex, direct);
    }
  }


  // ============================================
  // ACCORDIONS
  // ============================================
  function initAccordions() {
    const triggers = document.querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function(trigger) {
      const content = trigger.nextElementSibling;
      // Set initial max-height for already-open items
      if (content && content.classList.contains('is-open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      trigger.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (expanded) {
          // Close: set explicit height first, then collapse to 0
          content.style.maxHeight = content.scrollHeight + 'px';
          content.offsetHeight; // Force reflow
          content.style.maxHeight = '0';
          content.classList.remove('is-open');
        } else {
          // Open: expand to measured height
          content.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
          content.addEventListener('transitionend', function handler() {
            if (content.classList.contains('is-open')) {
              content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  // ============================================
  // SLIDING SIZE INDICATOR
  // ============================================
  function initSizeIndicator() {
    const strip = document.getElementById('StilenzaSizes');
    const indicator = document.getElementById('StilenzaSizesIndicator');
    if (!strip || !indicator) return;

    function moveIndicator(btn) {
      indicator.style.width = btn.offsetWidth + 'px';
      indicator.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
    }

    // Set initial position without animation
    const initial = strip.querySelector('.stil-pdp__size.is-selected');
    if (initial) {
      indicator.style.transition = 'none';
      moveIndicator(initial);
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          indicator.style.transition = '';
        });
      });
    } else {
      indicator.style.opacity = '0';
    }

    // On size click — slide indicator to clicked button
    strip.querySelectorAll('.stil-pdp__size').forEach(function(btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function() {
        indicator.style.opacity = '1';
        moveIndicator(this);
      });
    });
  }

  // ============================================
  // STICKY ATC (mobile)
  // ============================================
  function initStickyATC() {
    const atcWrap = document.getElementById('StilenzaATCWrap');
    const stickyBar = document.getElementById('StilenzaStickyATC');
    if (!atcWrap || !stickyBar) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          // Only show sticky when ATC has been scrolled past (not before reaching it)
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    _observers.push(observer);

    observer.observe(atcWrap);

    // Sticky button triggers the main form submit
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        if (!stickyBtn.disabled && form) {
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit'));
        }
      });
    }
  }

  // ============================================
  // AJAX ADD TO CART
  // ============================================
  function initAJAXCart() {
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Size validation — shake if no size selected
      const sizeWrap = document.querySelector('.stil-pdp__sizes');
      if (sizeWrap && !sizeWrap.querySelector('.is-selected')) {
        sizeWrap.classList.add('is-shaking');
        const sizeLabel = sizeWrap.closest('.stil-pdp__option');
        if (sizeLabel) {
          const labelEl = sizeLabel.querySelector('.stil-pdp__option-label');
          if (labelEl) labelEl.classList.add('is-error');
        }
        setTimeout(function() {
          sizeWrap.classList.remove('is-shaking');
          if (sizeLabel) {
            const labelEl2 = sizeLabel.querySelector('.stil-pdp__option-label');
            if (labelEl2) setTimeout(function() { labelEl2.classList.remove('is-error'); }, 2000);
          }
        }, 300);
        sizeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const formData = new FormData(form);
      atcBtn.disabled = true;
      zetKoopKnop(_labels.labelAdding || 'ADDING...', '');
      if (stickyBtn) {
        stickyBtn.disabled = true;
        // Prijs laten staan: hem hier weghalen laat de knop in breedte springen
        // op het moment dat je erop drukt.
        zetStickyKnop(_labels.labelAdding || 'ADDING...', huidigePrijsTekst());
      }

      var R = window.routes || {};
      const voegToe = voegProductToe(formData);
      voegToe
      .then(function(res) {
        if (!res.ok) throw new Error('add status ' + res.status);
        return res.json();
      })
      .then(function(data) {
        // Update cart count badge
        if (window.__stilUpdateCartBadge) window.__stilUpdateCartBadge();

        // Open cart drawer immediately — the drawer opening IS the confirmation
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          fetch((R.cart_url || '/cart') + '?sections=cart-drawer')
            .then(function(r) { return r.json(); })
            .then(function(sections) {
              const html = sections['cart-drawer'];
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newContent = doc.querySelector('cart-drawer');
              if (newContent) cartDrawer.innerHTML = newContent.innerHTML;
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open(atcBtn);
              resetATCButton();
            });
        } else {
          window.location.href = R.cart_url || '/cart';
        }
      })
      .catch(function(err) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('is-success');
        zetKoopKnop(_labels.labelError || 'ERROR \u2014 TRY AGAIN', '');
        if (stickyBtn) {
          stickyBtn.disabled = false;
          stickyBtn.classList.remove('is-success');
          // Hier wel zonder prijs: "ERROR — TRY AGAIN €47,95" leest nergens naar.
          zetStickyKnop(_labels.labelError || 'ERROR \u2014 TRY AGAIN', '');
        }
        setTimeout(resetATCButton, 3000);
      });
    });
  }

  function resetATCButton() {
    const variant = findVariantById(parseInt(variantInput.value));
    if (!variant) return;
    const price = formatPrice(variant.price);
    atcBtn.disabled = false;
    atcBtn.classList.remove('is-success');
    zetKoopKnop(_labels.labelAddToBag || 'ADD TO CART', price);
    if (stickyBtn) {
      stickyBtn.disabled = false;
      stickyBtn.classList.remove('is-success');
      // Met textContent verdwenen hier de twee spans, en daarmee de prijs: na
      // een keer toevoegen en de lade weer sluiten stond er alleen nog
      // "ADD TO BAG". De prijs werd hierboven al berekend maar nergens gebruikt
      // - de linter meldde die variabele niet voor niets.
      zetStickyKnop(_labels.labelAddToBag || 'ADD TO BAG', price);
    }
  }

  // Het hartje op de productpagina is weg — twee knoppen naast de koopknop
  // trokken aan hetzelfde moment. De wishlist zit in de productkaart, de header
  // en de menu drawer; de afhandeling daarvan staat in assets/stilenza-wishlist.js.

  // Shopify applies the storewide automatic tiers; adding needs no theme marker.
  function voegProductToe(formData) {
    const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/*$/, '/');
    return fetch(root + 'cart/add.js', { method: 'POST', body: formData });
  }

  // ============================================
  // RECENTLY VIEWED (localStorage)
  // ============================================
  // Achtervoegsel voor de opslagsleutel, uniek per markt en taal. Staat hier zodat
  // sections/stilenza-recently-viewed.liquid dezelfde afleiding kan gebruiken —
  // lopen die twee uiteen, dan schrijft de PDP naar een lijst die de sectie niet leest.
  function recentlyViewedScope() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root === '/' ? '' : '_' + root.replace(/^\/|\/$/g, '');
  }
  window.__stilRecentlyViewedScope = recentlyViewedScope;

  function initRecentlyViewed() {
    // Per markt een eigen lijst. Titel en prijs worden opgeslagen zoals ze op het
    // moment van bekijken waren; met één gedeelde lijst kreeg een Japanse bezoeker
    // Engelse titels te zien en — erger — bedragen in de oude valuta met het nieuwe
    // valutateken ervoor. Shopify.routes.root is per markt en taal uniek ('/',
    // '/ja-jp/', '/fr-fr/'), dus die is meteen de scheiding.
    const key = 'stilenza_recently_viewed' + recentlyViewedScope();
    const max = 12;

    // Save current product
    const current = {
      handle: product.handle,
      title: product.title,
      url: ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + product.handle,
      image: product.featured_image,
      price: product.price
    };
    let items = [];
    try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) { items = []; }
    items = items.filter(function(i) { return i.handle !== current.handle; });
    items.unshift(current);
    if (items.length > max) items = items.slice(0, max);
    try { localStorage.setItem(key, JSON.stringify(items)); } catch(e) { /* silently handled */ }

    // Render (exclude current)
    const toShow = items.filter(function(i) { return i.handle !== current.handle; });
    if (toShow.length === 0) return;

    const container = document.getElementById('StilenzaRecentlyViewed');
    if (!container) return;
    container.style.display = 'block';
    // Zichtbaar zetten mag hier al: valt het ophalen straks stil, dan verbergt
    // haalKaarten() hem weer. Andersom (pas tonen na het antwoord) laat het
    // blok zichtbaar springen tijdens het scrollen.
    const grid = container.querySelector('.stz__strook') || container.querySelector('.stil-pdp__grid') || container.querySelector('.stz__grid');
    if (!grid) return;

    // DE ECHTE KAART, NIET EEN NAMAAK.
    // Hier stond een kaart die in javascript werd opgebouwd uit wat er in
    // localStorage lag: foto, titel, prijs. Daarmee miste hij alles wat de
    // kaarten elders dragen — sterren, bespaard bedrag, kleurstalen — en zag
    // hetzelfde product er onderaan de productpagina armer uit dan op de
    // collectiepagina. Meer opslaan zou een tweede productkaart betekenen die
    // naast de echte uit de pas loopt.
    //
    // Nu vraagt de winkel de kaart zelf: sections/stilenza-kaart-los.liquid
    // rendert één product met dezelfde snippet als overal. Pas ophalen als de
    // sectie in beeld komt — hij staat onderaan, dus dat scheelt verzoeken bij
    // wie nooit zo ver scrollt.
    const wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const tonen = toShow.slice(0, 8);

    function haalKaarten() {
      Promise.all(tonen.map(function(item) {
        const handle = item.handle || ((item.url || '').match(/\/products\/([^\/?#]+)/) || [])[1];
        if (!handle) return Promise.resolve(null);
        return fetch(wortel + 'products/' + handle + '?section_id=stilenza-kaart-los')
          .then(function(r) { return r.ok ? r.text() : null; })
          .catch(function() { return null; });
      })).then(function(stukken) {
        const geldig = stukken.filter(Boolean);
        if (!geldig.length) { container.style.display = 'none'; return; }
        // De Section Rendering API levert de sectie in een wikkel; alleen de
        // kaart zelf hoort in het raster.
        const ontleder = new DOMParser();
        geldig.forEach(function(html) {
          const kaart = ontleder.parseFromString(html, 'text/html').querySelector('.stil-card');
          if (kaart) grid.appendChild(kaart);
        });
        if (!grid.children.length) container.style.display = 'none';
      });
    }

    if ('IntersectionObserver' in window) {
      const kijker = new IntersectionObserver(function(rijen) {
        if (rijen.some(function(r) { return r.isIntersecting; })) {
          kijker.disconnect();
          haalKaarten();
        }
      }, { rootMargin: '600px' });
      kijker.observe(container);
      _observers.push(kijker);
    } else {
      haalKaarten();
    }
  }

  // ============================================
  // WEAR IT WITH — complementaire rijen + add-all
  // ============================================
  function initLook() {
    const el = document.getElementById('StilenzaLook');
    if (!el) return;
    const rows = document.getElementById('StilenzaLookRows');


    if (rows.querySelector('.stz__lrow')) {
      el.style.display = '';
      return;
    }
    fetch(el.dataset.url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nieuw = doc.getElementById('StilenzaLookRows');
        if (nieuw && nieuw.querySelector('.stz__lrow')) {
          rows.innerHTML = nieuw.innerHTML;
          el.style.display = '';
            } else {
          el.remove();
        }
      })
      .catch(function() { el.remove(); });
  }

  // Spoor D (aug 2026): initUrgency (verzonnen kijkers-teller) en initSaleTimer
  // (wekelijks herstartende countdown) verwijderd — nooit-lijst.
  // Zie docs\pdp-cvr-werkboek.md.

  // ============================================
  // KOERIER VOLGT HET LAND VAN DE BEZOEKER
  // ============================================
  // Liquid kent alleen de markt. Landen zonder eigen Shopify-markt vallen terug
  // op de standaardmarkt en kregen daardoor het verkeerde koerierslogo — een
  // Australiër zag PostNL. Shopify weet het echte land wel: hetzelfde eindpunt
  // dat de "ga je naar de winkel van jouw land?"-melding voedt. Bestaat er een
  // logo voor dat land, dan wisselen logo én naam in één keer om.
  //
  // Alleen het logo wisselt, nooit de prijs of de markt: dat blijft aan Shopify.
  // Het logo is een herkenningspunt ("de post die ik ken bezorgt dit"), en dat
  // klopt ook als de bestelling in de standaardmarkt wordt afgerekend.
  function initKoerierPerLand() {
    const blok = document.querySelector('[data-usp-koerier]');
    if (!blok) return;
    const bron = blok.querySelector('script[data-usp-koeriers]');
    const naamEl = blok.querySelector('[data-usp-koeriernaam]');
    if (!bron || !naamEl) return;

    let cfg;
    try { cfg = JSON.parse(bron.textContent); } catch (e) { return; }
    if (!cfg || !cfg.lijst) return;

    const wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const start = function() {
      fetch(wortel.replace(/\/$/, '') + '/browsing_context_suggestions.json', {
        headers: { Accept: 'application/json' }
      })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(d) {
          const land = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          if (!land || land === cfg.markt) return;
          // Heeft dit land een eigen markt, dan blijven we eraf: de markt is
          // dan een keuze (van Shopify of van de klant) en die weet beter waar
          // het pakket heen gaat dan het IP-adres van dit moment.
          if (Array.isArray(cfg.landen) && cfg.landen.indexOf(land) !== -1) return;
          const k = cfg.lijst[land];
          if (!k) return;

          // Eerst het beeld inladen, dan pas allebei wisselen. Anders staat er
          // even een naam zonder het logo dat erbij hoort — precies de mismatch
          // die we hier juist weghalen.
          const beeld = new Image();
          beeld.onload = function() {
            const oud = blok.querySelector('.stz__ulogo');
            if (oud) {
              oud.innerHTML = '';
              beeld.className = 'stz__courier';
              beeld.alt = '';
              oud.appendChild(beeld);
            }
            naamEl.textContent = cfg.zin.replace('@@', k.n);
          };
          beeld.src = k.u;
        })
        .catch(function() { /* markt-versie blijft staan */ });
    };

    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 });
    else setTimeout(start, 600);
  }

  // ============================================
  // PRICE SPLIT — currency symbol smaller weight
  // ============================================
  function initPriceSplit() {
    const currentPriceEl = document.querySelector('.stil-pdp__price-current');
    if (currentPriceEl) {
      const text = currentPriceEl.textContent.trim();
      currentPriceEl.innerHTML = text.replace(/^([^\d\s]+)/, '<span class="stil-pdp__price-currency">$1</span>');
    }
  }

  // ============================================
  // --- Boot ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pagehide', function() {
    _observers.forEach(function(o) { o.disconnect(); });
  });
})();
